<footer class="footer">
  <div class="footer-container">
    <div class="divider-line"></div>
    <div class="footer-content">
      <div class="social-section">
        <div class="social-icons">
          <a href="https://www.instagram.com/accounts/login/?next=%2Fshowlabapp%2F&source=omni_redirect"
            class="social-icon" aria-label="Instagram">
            <img src="assets/icons/insta_icon.png" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@showlabbb?_t=ZS-90oICbhigqO&_r=1" class="social-icon" aria-label="TikTok">
            <img src="assets/icons/tik_tok_icon.png" alt="TikTok" />
          </a>
          <a href="https://www.linkedin.com/company/showlabapp" class="social-icon" aria-label="LinkedIn">
            <img src="assets/icons/linked_in_icon.png" alt="LinkedIn" />
          </a>
          <a href="#" class="social-icon" aria-label="Email">
            <img src="assets/icons/email_icon_footer.png" alt="Email" />
          </a>
        </div>
      </div>
      <div class="footer-nav">
        <div class="logo-nav-section">
          <div style="width: 100%;">
            <img src="assets/icons/logo_with_name.png" alt="Showlab Logo" class="footer-logo" />

          </div>
          <nav class="footer-navigation">
            <a href="https://showlabapp.com" target="_blank" rel="noopener noreferrer" class="footer-nav-link">home</a>
            <a href="https://showlabapp.com" target="_blank" rel="noopener noreferrer" class="footer-nav-link">about
              Us</a>
            <a href="https://showlabapp.com/privacy-policy" target="_blank" rel="noopener noreferrer"
              class="footer-nav-link">privacy policy</a>
            <a href="https://showlabapp.com/terms-conditions" target="_blank" rel="noopener noreferrer"
              class="footer-nav-link">terms & conditions</a>
          </nav>

        </div>
      </div>
      <div class="footer-body">
        @if (router.url === '/sign-in') {
        <span>© showlab. All rights reserved.</span>
        }
        @else{
        <span>copyright Showlab App Pty Ltd. all rights reserved.</span>
        }
      </div>
    </div>
  </div>
</footer>